import React from 'react';
import styles from './SubmitEventModal.module.scss';

type ISubmitEventModal = {
  onSubmitEvent?: () => void;
  isAuthenticated?: boolean;
  lat?: number;
  lon?: number;
  locationName?: string;
};

const SubmitEventModal: React.FC<ISubmitEventModal> = ({
  onSubmitEvent,
  isAuthenticated = false,
  lat,
  lon,
  locationName = ''
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <p className={styles['coordinat']}>
          {locationName && (
            <>
              {locationName}
              <span>&nbsp;/&nbsp;</span>
            </>
          )}
          {`${lat?.toFixed(6)}, ${lon?.toFixed(6)}`}
        </p>
      </div>
      <div className={styles['content']}>
        <p className={styles['text']}>
          {isAuthenticated
            ? 'Do you see event here?'
            : 'Login to submit an event'}
        </p>
        <button className={styles['button']} onClick={onSubmitEvent}>
          {isAuthenticated ? 'Submit Event' : 'Login'}
        </button>
      </div>
    </div>
  );
};

export default SubmitEventModal;
